"use client";

import Link from "next/link";
import Button from "@/components/ui/Button";
import { useAuth } from "@/hooks/useAuth";

export default function Hero() {
  const { isExpert } = useAuth();

  return (
    <section className="w-full bg-white">

      {/* Hero-Bild */}
      <div
        className="relative w-full h-[500px] overflow-hidden flex items-center justify-center"
        style={{
          backgroundImage: "url('/hero.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="relative z-10 flex flex-col items-center gap-4">
          <h1 className="text-4xl font-bold text-gray-900">BMM Kompakt</h1>

          {/* Basic / Expert Anzeige */}
          <div className="flex bg-white rounded-full shadow-sm border border-gray-200 p-1">
            <span className={`px-5 py-1.5 rounded-full text-sm font-medium transition-colors ${
              !isExpert ? "bg-gray-900 text-white" : "text-gray-500"
            }`}>
              Basic
            </span>
            <span className={`px-5 py-1.5 rounded-full text-sm font-medium transition-colors ${
              isExpert ? "bg-gray-900 text-white" : "text-gray-500"
            }`}>
              Expert
            </span>
          </div>
        </div>
      </div>

      {/* Zweispaltiger Text + CTA */}
      <div className="w-full px-4 py-12 sm:px-6 lg:px-8 lg:py-14 2xl:px-16">
        <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2 lg:gap-12 2xl:gap-20">

          {/* Links: Headline + CTA */}
          <div className="flex flex-col gap-6">
            <h2 className="text-3xl font-bold text-gray-900 leading-tight">
              Betriebliche Mobilität verstehen.<br />
              Kosten senken.<br />
              Emissionen reduzieren.
            </h2>
            <p className="text-gray-500 text-sm">
              Das Tool für datenbasierte Entscheidungen im betrieblichen Mobilitätsmanagement.
            </p>
            <div>
              <Link href="/willkommen">
                <Button size="lg">Tool Starten</Button>
              </Link>
            </div>
          </div>

          {/* Rechts: Beschreibungstext */}
          <div className="bg-gray-50 rounded-2xl border border-gray-100 p-8">
            <p className="text-sm font-semibold text-blue-600 uppercase tracking-wide mb-3">
              Was ist BMM Kompakt?
            </p>
            <p className="text-gray-700 text-sm leading-relaxed">
              BMM Kompakt analysiert Ihre betriebliche Mobilität, zeigt versteckte Kosten auf
              und identifiziert konkrete Maßnahmen für eine nachhaltigere und effizientere Gestaltung.
            </p>
            <div className="mt-6 flex flex-col gap-3">
              {[
                "Mobilitätsdaten strukturiert erfassen",
                "Kostenanalyse auf einen Blick",
                "Konkrete Maßnahmen ableiten",
              ].map((punkt) => (
                <div key={punkt} className="flex items-center gap-2.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-blue-500 shrink-0" />
                  <span className="text-sm text-gray-600">{punkt}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

    </section>
  );
}
